<app-select-clinic
  class="main-clinic-select"
  [showSingleClinic]="false"
  (changeClinic)="loadClinic($event)"
></app-select-clinic>
<div
  *ngIf="(mobileBreakpoint$ | async) === false; else mobileFilter"
  class="btn-group d-flex align-items-center flex-wrap grey-seven-background px-4 py-3"
>
  <button
    type="button"
    class="btn btn--arrow em-btn medium em-btn-nav-tab mr-1"
    [class.selected]="activeDateFilter === filterRanges.Today || activeDateFilter === filterRanges.Picker"
    [disabled]="activeDateFilter !== filterRanges.Today && activeDateFilter !== filterRanges.Picker"
    (click)="incrementRangeBy(-1)"
  >
    <i class="fal fa-chevron-left white-font small"></i>
  </button>
  <button
    type="button"
    class="btn medium em-btn em-btn-nav-tab mr-1 flex-nowrap"
    [class.selected]="activeDateFilter === filterRanges.Today"
    (click)="filterByPresetRange(filterRanges.Today)"
  >
    TODAY
  </button>
  <button
    type="button"
    class="btn btn--arrow em-btn medium em-btn-nav-tab mr-4"
    [class.selected]="activeDateFilter === filterRanges.Today || activeDateFilter === filterRanges.Picker"
    [disabled]="activeDateFilter !== filterRanges.Today && activeDateFilter !== filterRanges.Picker"
    (click)="incrementRangeBy(1)"
  >
    <i class="fal fa-chevron-right white-font small"></i>
  </button>
  <button
    type="button"
    class="btn medium em-btn em-btn-nav-tab mr-4 flex-nowrap"
    [class.selected]="activeDateFilter === filterRanges.Week"
    (click)="filterByPresetRange(filterRanges.Week)"
  >
    THIS WEEK
  </button>
  <button
    type="button"
    class="btn medium em-btn em-btn-nav-tab mr-4 flex-nowrap"
    [class.selected]="activeDateFilter === filterRanges.Month"
    (click)="filterByPresetRange(filterRanges.Month)"
  >
    THIS MONTH
  </button>
  <button
    type="button"
    class="btn medium em-btn em-btn-nav-tab mr-4 flex-nowrap"
    [class.selected]="activeDateFilter === filterRanges.LastMonth"
    (click)="filterByPresetRange(filterRanges.LastMonth)"
  >
    LAST MONTH
  </button>
  <button
    type="button"
    class="btn medium em-btn em-btn-nav-tab mr-4 flex-nowrap"
    [class.selected]="activeDateFilter === filterRanges.ThreeMonths"
    (click)="filterByPresetRange(filterRanges.ThreeMonths)"
  >
    THREE MONTHS
  </button>
  <button
    type="button"
    class="btn medium em-btn em-btn-nav-tab mr-4 flex-nowrap"
    [class.selected]="activeDateFilter === filterRanges.YearToDate"
    (click)="filterByPresetRange(filterRanges.YearToDate)"
  >
    YTD
  </button>
  <div>
    <mat-form-field floatLabel="always" class="mr-4 filter-date">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker">
        <input matStartDate formControlName="start" placeholder="Start" />
        <input matEndDate formControlName="end" placeholder="End" (dateChange)="onEndDateSet($event)" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <button type="button" class="btn medium em-btn em-btn-green lex-nowrap mr-4" (click)="clearFilter()">
    CLEAR FILTERS
  </button>
  <button
    *ngIf="(mobileBreakpoint$ | async) === false"
    type="button"
    class="btn medium em-btn em-btn-green flex-nowrap"
    (click)="exportToExcel()"
  >
    Export Excel
  </button>
</div>

<ng-template #mobileFilter>
  <div class="m-2 d-flex align-items-center">
    <mat-form-field *ngIf="activeDateFilter !== filterRanges.Picker" floatLabel="always" class="flex-grow-1">
      <mat-label>Date Range</mat-label>
      <mat-select [value]="activeDateFilter" (selectionChange)="filterByPresetRange($event.value)" class="p-3">
        <mat-option [value]="filterRanges.Today">TODAY</mat-option>
        <mat-option [value]="filterRanges.Week">THIS WEEK</mat-option>
        <mat-option [value]="filterRanges.Month">THIS MONTH</mat-option>
        <mat-option [value]="filterRanges.LastMonth">LAST MONTH</mat-option>
        <mat-option [value]="filterRanges.ThreeMonths">THREE MONTHS</mat-option>
        <mat-option [value]="filterRanges.YearToDate">YTD</mat-option>
        <mat-option [value]="filterRanges.Picker">CUSTOM</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="activeDateFilter === filterRanges.Picker" floatLabel="always" class="flex-grow-1">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input class="p-3 font-size-15" [formGroup]="dateRange" [rangePicker]="picker">
        <input matStartDate formControlName="start" placeholder="Start" />
        <input matEndDate formControlName="end" placeholder="End" (dateChange)="onEndDateSet($event)" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <div *ngIf="activeDateFilter === filterRanges.Picker" class="ml-3">
      <button class="btn btn-clean p-2" (click)="clearFilter()"><i class="fas fa-times fa-lg"></i></button>
    </div>
  </div>
</ng-template>

<div class="flex-grow-1 minh-0 d-flex flex-column" [ngClass]="{ 'px-4 py-3': (mobileBreakpoint$ | async) === false }">
  <nav *ngIf="authorizedTabs.size > 1" mat-tab-nav-bar class="border-0">
    <button
      *ngFor="let tab of authorizedTabs | keyvalue"
      mat-tab-link
      class="btn btn--tab text-uppercase em-btn-nav-tab mr-2"
      [class.selected]="activeTab === tab.key"
      [active]="activeTab === tab.key"
      (click)="activeTab = tab.key"
    >
      {{ tab.key | uppercase }}
    </button>
  </nav>

  <app-clinic-reports class="flex-grow-1 minh-0" *ngIf="defaultInitialized && activeTab === 'Clinic'" #reportTab>
  </app-clinic-reports>

  <app-liabilities-report
    class="flex-grow-1 minh-0"
    *ngIf="defaultInitialized && activeTab === 'Liabilities'"
    #reportTab
  >
  </app-liabilities-report>

  <app-patient-reports class="flex-grow-1 minh-0" *ngIf="defaultInitialized && activeTab === 'Patients'" #reportTab>
  </app-patient-reports>

  <app-product-reports class="flex-grow-1 minh-0" *ngIf="defaultInitialized && activeTab === 'Products'" #reportTab>
  </app-product-reports>

  <app-service-reports class="flex-grow-1 minh-0" *ngIf="defaultInitialized && activeTab === 'Services'" #reportTab>
  </app-service-reports>

  <app-provider-reports class="flex-grow-1 minh-0" *ngIf="defaultInitialized && activeTab === 'Providers'" #reportTab>
  </app-provider-reports>

  <app-invoices-reports class="flex-grow-1 minh-0" *ngIf="defaultInitialized && activeTab === 'Invoices'" #reportTab>
  </app-invoices-reports>

  <app-supplies-reports
    class="flex-grow-1 minh-0"
    *ngIf="defaultInitialized && activeTab === 'Clinic Supplies'"
    #reportTab
  >
  </app-supplies-reports>

  <app-commissions-reports
    class="flex-grow-1 minh-0"
    *ngIf="defaultInitialized && activeTab === 'Commissions'"
    #reportTab
  >
  </app-commissions-reports>

  <app-memberships-reports
    class="flex-grow-1 minh-0"
    *ngIf="defaultInitialized && activeTab === 'Memberships'"
    #reportTab
  >
  </app-memberships-reports>

  <app-package-reports class="flex-grow-1 minh-0" *ngIf="defaultInitialized && activeTab === 'Packages'" #reportTab>
  </app-package-reports>
</div>

<app-actionpanel></app-actionpanel>
